<template>
    <div class="tab-pane fade" id="storages">
        <h3>Hàng chờ xuất</h3>
        <div class="table-responsive">
            <hpo-filter :headers="headers" :viewName="'account_storages'" v-on:applyFilter="applyFilter"
                v-on:quickFilter="quickFilter"></hpo-filter>
            <v-data-table :headers="headers" :items="storages" :options.sync="pagination"
                :server-items-length="total" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                :mobile-breakpoint="100" class="elevation-1 free-col">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-left">{{ item.product_code }}</td>
                        <td class="text-left">
                            <b>{{ item.name }}</b>
                            <span v-if="isMobile">
                                <br>Số lượng: {{ item.available_qty | currency }}
                                <br>Đơn giá: {{ item.price | currency }}
                                <br>Thành tiền: {{ item.line_total | currency }}
                            </span>
                        </td>
                        <td class="text-right">
                            {{ item.available_qty | currency }}
                        </td>
                        <td class="text-right">
                            {{ item.price | currency }}
                        </td>
                        <td class="text-right">
                            {{ item.line_total | currency }}
                        </td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary">
                    <tr class="total-summary-td">
                        <td colspan="2" class="font-weight-bold text-left">Tổng
                            <span v-if="isMobile">
                                <br>Số lượng: {{ summary.available_qty | currency }}
                                <br>Thành tiền: {{ summary.line_total | currency }}
                            </span>
                        </td>
                        <td class="text-end font-weight-bold">{{ summary.available_qty | currency }}</td>
                        <td class="text-end font-weight-bold"></td>
                        <td class="text-end font-weight-bold">{{ summary.line_total | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { pad } from '@/commons/utils'
export default {
    components: {
        "hpo-filter": Filtering
    },
    data () {
        return {
            viewName: "account_storages",
            pad: pad,
            display_color: display_color,
            headers: [
                {
                    text: "Mã SP",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                    width: 100
                },
                {
                    text: "Tên SP",
                    value: "product_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                    width: 200
                },
                {
                    text: "SL",
                    value: "available_qty",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                    width: 50
                },
                {
                    text: "Giá bán",
                    value: "price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                    width: 100
                },
                {
                    text: "Thành tiền",
                    value: "line_total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                }
            ],
            pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            selectedItem: null,
            dialogItem: false
        }
    },
    computed: {
        ...mapState({
            storages: state => state.products.exp.data,
            total: state => state.products.exp.total,
            summary: state => state.products.exp.summary,
            loading: state => state.products.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_storages'] : []
                this.filter_data();
            },
            deep: true
        }
    },
    methods: {
        isMobile() {
            if( screen.width <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        },
        refresh_data() {
            this.filter_data();
        },
        filter_data() {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions,
                customer_id: this.customer_id
            };
            this.$store.dispatch("products/getExpList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
    },
    mounted () {
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>